import { onCompletePaymentSurvey } from "@pageDefinitions/actions/survey/onCompletePaymentSurvey";
import { onCompleteEmployerSurvey } from "@pageDefinitions/actions/survey/onCompleteEmployerSurvey";
import { onStartMainSurvey } from "@pageDefinitions/actions/survey/onStartMainSurvey";
import { onCompleteMainSurvey } from "@pageDefinitions/actions/survey/onCompleteMainSurvey";
import { onCompleteLandingPageSurvey } from "@pageDefinitions/actions/survey/onCompleteLandingPageSurvey";
import { mixpanelTrackAction } from "@pageDefinitions/actions/tracking";

import { GoToPageOptions } from "../goto/pageSet";
import { PageListEntry, PageSet } from "../types";
import { onStartSurvey } from "./survey/onStartSurvey";
import { saveAnswers, saveNoomPremiumAnswers } from "./survey/saveAnswers";
import { SaveEventToBraze } from "./saveToBraze";
import { saveToSession } from "./session";
import { onCompleteTelehealthFeedbackSurvey } from "@pageDefinitions/actions/survey/onCompleteTelehealthFeedbackSurvey";
import { onStartTelehealthFeedbackSurvey } from "@pageDefinitions/actions/survey/onStartTelehealthFeedbackSurvey";

export type ActionHandlerParams = {
  params: JsonObject;
  pageSet: PageSet;
  page: PageListEntry;
} & GoToPageOptions;

export type ActionHandler = (
  params: ActionHandlerParams
) => void | Promise<void>;

const ACTIONS = {
  TRACK: mixpanelTrackAction,
  SAVE_EVENT_TO_BRAZE: SaveEventToBraze,

  SAVE_TO_SESSION: saveToSession,

  SAVE_ANSWERS: saveAnswers,
  SAVE_NOOM_PREMIUM_ANSWERS: saveNoomPremiumAnswers,

  // Generic Survey
  ON_START_SURVEY: onStartSurvey,

  // Main Survey
  ON_START_MAIN_SURVEY: onStartMainSurvey,
  ON_COMPLETE_MAIN_SURVEY: onCompleteMainSurvey,

  // Payment Survey
  ON_COMPLETE_PAYMENT_SURVEY: onCompletePaymentSurvey,

  // Employer Survey
  ON_COMPLETE_EMPLOYER_SURVEY: onCompleteEmployerSurvey,

  // Telehealth Feedback Survey
  ON_START_TELEHEALTH_FEEDBACK_SURVEY: onStartTelehealthFeedbackSurvey,
  ON_COMPLETE_TELEHEALTH_FEEDBACK_SURVEY: onCompleteTelehealthFeedbackSurvey,

  // Landing page Survey
  ON_COMPLETE_LANDING_PAGE_SURVEY: onCompleteLandingPageSurvey,
};

export default ACTIONS;
